import styles from './TextInput.module.css';

type Props = {
	defaultValue?: string;
	onBlur?: (value: string) => void;
	placeholder?: string;
};

const TextInput = ({ defaultValue, onBlur, placeholder }: Props) =>
{
	return (
		<input
			className={styles.textInput}
			type="text"
			defaultValue={defaultValue}
			onBlur={(e) => onBlur?.(e.target.value)}
			onKeyDown={(e) =>
			{
				if (e.key === 'Enter')
				{
					e.currentTarget.blur();
				}
			}}
			placeholder={placeholder}
		/>
	);
};

export default TextInput;